export const CREATE_DEVICE_TUTORIAL_ID = '309824';
export const CREATE_EMPLOYEE_TUTORIAL_ID = '309432';
export const INVITE_EMPLOYEE_TUTORIAL_ID = '309808';
export const PUBLISH_SCHEDULE_TUTORIAL_ID = '309823';
export const CREATE_TEMPLATE_TUTORIAL_ID = '365344';
export const USE_GOOGLE_OAUTH_LOGIN_TUTORIAL_ID = '479476';
export const DISABLE_PAYROLL_APPROVAL_ENABLED_TUTORIAL_ID = '500231';
export const ENABLE_PAYROLL_APPROVAL_ENABLED_TUTORIAL_ID = '500501';
